import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateAgencyAuthenticationRequest extends BaseUpdateRequest {
	identityProvider = 2;
}
